import { Consumer } from '../context';

export default Consumer;



// WEBPACK FOOTER //
// ./src/lib/components/AuthConsumer.js